document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
  function replaceTextInDiv(element) {
        const inner = element.querySelector('.swal2-html-container')
        let html = inner.innerHTML;

        const replacements = {
            "Je bent besteld": "Je hebt besteld",
            "Total amount": "Totaal aantal beschikbaar",
            "out of": "van de"
        };

        Object.keys(replacements).forEach(function (key) {
            let regex = new RegExp("\\b" + key + "\\b", "g");
            html = html.replace(regex, replacements[key]);
        });

        html = html.replace(/(\d+)\s*van de\s*(\d+)/g, "$2 van de $1");

        inner.innerHTML = html;
    }

    const observer = new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1 && node.classList.contains("swal2-container")) {
                    replaceTextInDiv(node); // Когда появляется `div.swal2-popup`, меняем текст
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    document.querySelectorAll(".swal2-popup").forEach(replaceTextInDiv);
})